import {
	QR_LIST_REQUESTING,
	QR_DETAIL_REQUESTING,
	DISABLED_QR_LIST_REQUESTING,
	VERIFY_OTP,
	GET_OTP,
	DELETE_NOTIFICATION_RECEIVER,
	CLEAR_OTP,
	DOWNLOAD_QR,
	TERMINAL_LIST_REQUESTING,
	TOTAL_TERMINAL_LIST_REQUESTING,
	UPDATE_QR_DETAILS,
} from './types';

const qrListRequesting = (payload) => ({
	type: QR_LIST_REQUESTING,
	payload,
});

const disabledQrListRequesting = (payload) => ({
	type: DISABLED_QR_LIST_REQUESTING,
	payload,
});

const qrDetailRequesting = (payload) => ({
	type: QR_DETAIL_REQUESTING,
	payload,
});

const updateQRDetails = (payload) => ({
	type: UPDATE_QR_DETAILS,
	payload,
});

const getOTP = (payload) => ({
	type: GET_OTP,
	payload,
});

const verifyOTP = (payload) => ({
	type: VERIFY_OTP,
	payload,
});

const clearOTP = (payload) => ({
	type: CLEAR_OTP,
	payload,
});

const downloadQR = (payload) => ({
	type: DOWNLOAD_QR,
	payload,
});

const deleteNotificationReceiver = (payload) => ({
	type: DELETE_NOTIFICATION_RECEIVER,
	payload,
});

const terminalListRequesting = (payload) => ({
	type: TERMINAL_LIST_REQUESTING,
	payload,
});

const totalTerminalListRequesting = (payload) => ({
	type: TOTAL_TERMINAL_LIST_REQUESTING,
	payload,
});

export {
	qrListRequesting,
	qrDetailRequesting,
	updateQRDetails,
	getOTP,
	verifyOTP,
	clearOTP,
	downloadQR,
	deleteNotificationReceiver,
	terminalListRequesting,
	disabledQrListRequesting,
	totalTerminalListRequesting,
};
